import { Injectable } from '@angular/core';
import { assert } from '@sama/js-core';

@Injectable()
export class FeatureFlagService {
  private flags?: Set<string>;

  setFlags(flags: string[]) {
    this.flags = new Set<string>(flags);
  }

  hasFlag(flag: string) {
    assert(this.flags, 'Make sure you fetch feature flags first');
    return this.flags.has(flag);
  }
}
